import { render } from "./HostFinancialSetupAlert.vue?vue&type=template&id=e8be43dc&scoped=true"
import script from "./HostFinancialSetupAlert.vue?vue&type=script&lang=js"
export * from "./HostFinancialSetupAlert.vue?vue&type=script&lang=js"

import "./HostFinancialSetupAlert.vue?vue&type=style&index=0&id=e8be43dc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8be43dc"]])

export default __exports__